import { render } from "./About.vue?vue&type=template&id=3eba6759&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=3eba6759&scoped=true&lang=css"

import exportComponent from "/home/frog/Documents/vue/FEVO/fevo_site/fevo_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eba6759"]])

export default __exports__